class CapViewAllOneTimeRides {
    constructor(config) {
        this.config = config
    }

    checkPermission() {
        return Boolean(this.config)
    }
}

function key() {
    return 'view_all_one_time_rides'
}

function create(config) {
    return new CapViewAllOneTimeRides(config)
}

export default {
    key,
    create,
}